module.exports = require("redbox-react");